import { REHYDRATE } from 'redux-persist';
import initialState from './snippet.initialstate';

const INITIAL_STATE = { snippets: initialState };
const snippetReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REHYDRATE:
      if (!action.payload) {
        return state;
      }
      return {
        ...action.payload.snippetState,
      };
    case 'PUBLIC_SNIPPET_ADD':
      return {
        snippets: {
          ...state.snippets,
          public: {
            ...state.snippets.public,
            [action.snippet.key]: {
              ...action.snippet,
              snippetLength: action.snippet.snippet.length,
            },
          },
        },
      };
    case 'PRIVATE_SNIPPET_ADD':
      return {
        snippets: {
          ...state.snippets,
          private: {
            ...state.snippets.private,
            [action.snippet.key]: {
              ...action.snippet,
              snippetLength: action.snippet.snippet.length,
            },
          },
        },
      };
    case 'SNIPPET_ADD':
      const snippetLength = action.snippet.snippet.length;
      return {
        snippets: {
          ...state.snippets,
          [action.snippet.key]: {
            snippetLength,
            ...action.snippet,
          },
        },
      };
    case 'ADD_SNIPPETS':
      return {
        ...state,
        ...action.payload.reduce((acc, cv) => {
          acc[cv.id] = cv;
          return acc;
        }, {}),
      };
    default:
      return state;
  }
};

export default snippetReducer;
